import React, { Fragment } from 'react'
import {
    Show,
    SimpleShowLayout,
    TextField,
    NumberField,
    EmailField,
} from 'react-admin'

import Title from '../Generic/Title'


export const UsuarioCoordinadoShow = props => {
    // const role = localStorage.getItem("role");
    return (
        <Fragment>
            <Title title={"Perfil Usuario"} />
            <Show {...props}>
                <SimpleShowLayout>
                    <NumberField source="id" />
                    <TextField source="username" />
                    <EmailField source="email" />
                    <TextField source="first_name" />
                    <TextField source="last_name" />
                </SimpleShowLayout>
            </Show>
        </Fragment>
    )
};
